import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtagService {
  private win: any;

  constructor() {
    this.win = window as any;
  }

  gtag(...args: any[]) {
    if (this.win.gtag) {
      this.win.gtag(...args);
    }
  }
}
